import { createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import {
    CreditParameter,
    getActiveCardLimit,
    ReleaseCreditLimit,
} from "@theStellarBlueprint/Services/ReleaseCreditService";
import { CustomApiHandler } from "@theStellarBlueprint/Store/CustomHandlerCreator";

type HandlerType = CustomApiHandler<ReleaseCreditLimit, CreditParameter>;

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = props.parameter;
};

export const RequestDataFromApi: HandlerType = async props => {
    try {
        // Make API call using populated `apiParameter`
        props.apiResult = await getActiveCardLimit(props.apiParameter);
    } catch (error) {
        console.error("Error while fetching Card Limit:", error);
    }
};

// Combine the handlers into a chain
export const chain = [PopulateApiParameter, RequestDataFromApi];

// Create a handler chain runner
const getCreditLimitData = createHandlerChainRunner(chain, "getCreditLimit");

export default getCreditLimitData;
